import React from 'react'
import AnsQandAUserAll from '../../ansuser/AnsQandAUserAll'
import NavPatient from '../../patients/navPatien/NavPatient'

function AnsPatient() {
    return (
        <div className='global-page'>
            <NavPatient menu={'ans'} />
            <AnsQandAUserAll roleUser={'Patient'} />
        </div >
    )
}

export default AnsPatient